module.exports = __webpack_public_path__ + "static/img_reward_02@2x-bc6b670556bcd3698f545aba5e0a1d3d.png";